import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";

const AndroidAppDrawer = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [isDismissed, setIsDismissed] = useState(false);

	useEffect(() => {
		// Check if user is on Android
		const isAndroid = /Android/i.test(navigator.userAgent);

		// Check if user has previously dismissed the drawer
		const hasBeenDismissed = localStorage.getItem("androidAppDrawerDismissed") === "true";

		if (isAndroid && !hasBeenDismissed && !isDismissed) {
			// Show drawer after a short delay
			const timer = setTimeout(() => {
				setIsOpen(true);
			}, 2000);

			return () => clearTimeout(timer);
		}
	}, [isDismissed]);

	const handleClose = () => {
		setIsOpen(false);
		setIsDismissed(true);
		localStorage.setItem("androidAppDrawerDismissed", "true");
	};

	const handleDownload = () => {
		window.open("https://play.google.com/store/apps/details?id=com.dproz.app", "_blank");
		handleClose();
	};

	return (
		<AnimatePresence>
			{isOpen && (
				<>
					{/* Backdrop */}
					<motion.div
						className="fixed inset-0 bg-black bg-opacity-30 z-[998]"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						onClick={handleClose}
					/>

					{/* Bottom Drawer */}
					<motion.div
						className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl z-[999]"
						initial={{ y: "100%" }}
						animate={{ y: 0 }}
						exit={{ y: "100%" }}
						transition={{ type: "spring", stiffness: 300, damping: 30 }}
					>
						<div className="p-6 pb-8">
							{/* Close button */}
							<button
								className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
								onClick={handleClose}
								aria-label="Close"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="h-6 w-6"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
								>
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
								</svg>
							</button>

							{/* Content */}
							<div className="flex items-start gap-4">
								{/* App Icon */}
								<div className="flex-shrink-0">
									<img src="/images/logo.png" alt="Dproz App" className="w-16 h-16 object-contain rounded-xl" />
								</div>

								{/* Text Content */}
								<div className="flex-1">
									<h3 className="text-lg font-bold text-gray-900 mb-1 font-plus-jakarta">Get the Dproz App</h3>
									<p className="text-sm text-gray-600 mb-4 font-inter">
										Download our Android app for a better experience. Find jobs, build your resume, and manage
										applications on the go!
									</p>

									{/* Action Buttons */}
									<div className="flex gap-3">
										<button
											onClick={handleDownload}
											className="flex-1 bg-primary-600 text-white px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors font-inter flex items-center justify-center gap-2"
										>
											<svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
												<path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
											</svg>
											Download on Google Play
										</button>
									</div>
								</div>
							</div>
						</div>
					</motion.div>
				</>
			)}
		</AnimatePresence>
	);
};

export default AndroidAppDrawer;
